@use "/src/styles/functions";
@use "/src/styles/mixins";

.button {
  display: flex;

  transition: all 0.3s ease-in-out;
  cursor: pointer;
  outline: none;
  border: none;
  background-color: transparent;

  overflow: hidden;

  --button-base-color: rgba(var(--theme-static-static-white));
  --button-hover-color: rgba(var(--theme-static-static-white));
  --button-focus-color: rgba(var(--theme-static-static-white));

  color: var(--button-base-color);

  &:hover {
    color: var(--button-hover-color);
  }

  &:focus,
  &:active {
    color: var(--button-focus-color);
    text-decoration: underline;
  }

  &__container {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: functions.space(4);
  }

  &[data-size="medium"] {
    @include mixins.fontType(label-small);

    .button__container {
      gap: functions.space(4);
    }
  }
  &[data-size="small"] {
    @include mixins.fontType(label-x-small);

    .button__container {
      gap: functions.space(4);
    }
  }

  &[data-variant="gray"] {
    --button-base-color: rgba(var(--theme-text-sub-600));
    --button-hover-color: rgba(var(--theme-text-sub-600));
    --button-focus-color: rgba(var(--theme-text-strong-900));
  }
  &[data-variant="black"] {
    --button-base-color: rgba(var(--theme-text-strong-900));
    --button-hover-color: rgba(var(--theme-text-strong-900));
    --button-focus-color: rgba(var(--theme-text-strong-900));
  }
  &[data-variant="primary"] {
    --button-base-color: rgba(var(--theme-primary-base));
    --button-hover-color: rgba(var(--theme-primary-dark));
    --button-focus-color: rgba(var(--theme-primary-base));
  }
  &[data-variant="secondary"] {
    --button-base-color: rgba(var(--theme-secondary-600));
    --button-hover-color: rgba(var(--theme-secondary-700));
    --button-focus-color: rgba(var(--theme-secondary-600));
  }
  &[data-variant="success"] {
    --button-base-color: rgba(var(--theme-state-success-base));
    --button-hover-color: var(--color-green-700);
    --button-focus-color: rgba(var(--theme-state-success-base));
  }
  &[data-variant="error"] {
    --button-base-color: rgba(var(--theme-state-error-base));
    --button-hover-color: var(--color-red-700);
    --button-focus-color: rgba(var(--theme-state-error-base));
  }
  &[data-variant="modifiable"] {
    --button-base-color: rgba(var(--theme-text-white-0));
    --button-hover-color: rgba(var(--theme-text-white-0));
    --button-focus-color: rgba(var(--theme-text-white-0));
  }

  &[data-disabled="true"] {
    cursor: not-allowed;
    --button-base-color: rgba(var(--theme-text-disabled-300)) !important;
    --button-hover-color: rgba(var(--theme-text-disabled-300)) !important;
    --button-focus-color: rgba(var(--theme-text-disabled-300)) !important;
  }

  &__link {
    text-decoration: none;
    color: unset;

    &[data-underline="true"] {
      text-decoration: underline;
    }
    &:hover,
    &:active,
    &:focus,
    &:visited {
      text-decoration: underline;
      color: unset;
    }
  }
}
